import { useEffect, useState } from 'react';
import { Typography, Button, Box, ButtonGroup, Divider, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { CreatFieldComponent } from './Fields';

import Modal from '@mui/material/Modal';
import { useData } from '../hooks/DataProvider';
import translations from '../scripts/translations';

import { ModelServiceItem } from '../models/ModelServiceItem';
import { ModelShipment } from '../models/ModelShipment';

import { taxationAutomaticForShipement, createNewServiceItem, calculateTotalsSummaryForShipement } from '../scripts/automaticTaxation';

import { determineVatRate } from '../scripts/utils';

import { Currencies, TaxRates, Units } from '../scripts/configData';

import { TierSelectBox } from './TierSelectBox';

import { BillingItemsSearchBox } from './BillingItemsSearchBox';


// Modal style extracted from inside ServiceList
const style = {
    position: 'absolute',
    top: '20%',
    left: '20%',
    transform: 'translate(-20%, -20%)',
    width: '90%',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
    maxHeight: '80vh',
    // minHeight: '300px',
};


const HeaderBlock = () => {


    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, mb: 2, justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', gap: 4, flexGrow: 1 }}>

                    <BlockText text={'totalHandlingUnits'} />
                    <BlockText text={'soWeight'} />
                    <BlockText text={'soChargeableWeight'} />
                    <BlockText text={'soVolume'} />
                    <BlockText text={'declaredValue'} currency={true} />
                </Box>

                <Box sx={{ display: 'flex', gap: 4, flexGrow: 1, flexDirection: 'row-reverse', textAlign: 'right' }}>
                    <BlockText text={'cost'} />
                    <BlockText text={'commercialMargin'} />
                    <BlockText text={'revenue'} />
                </Box>

            </Box>
        </>
    )
}


const BlockText = ({ text, currency = '' }) => {
    const { language, dataShipement, } = useData();
    return (
        <Typography variant='overline' color='#00000099' sx={{ fontWeight: 400 }} >
            {ModelShipment[text][language]} : {dataShipement[text]} {currency ? dataShipement['declaredCurrency'] : ''}
        </Typography>
    )
}






const SelectedItem = ({ ModelServiceItem, dataServiceListCurrentItem, setDataServiceListCurrentItem, setDataServiceList, language, page, handleDelete,}) => {


    const { dataShipement, setDataShipement } = useData();

    const [dataCustomerDropdown, setDataCustomerDropdown] = useState([]);

    const btns = translations.button[language];


    useEffect(() => {

        const arr = [];
        const Items = ['orderingParty', 'consignor', 'consignee', 'transShipment'];

        for (let i in Items) {
            let item = dataShipement[Items[i]];
            if (item && item._id) {
                arr.push({
                    _id: item._id,
                    code: item.code,
                    name: item.name,
                    countryCode: item.countryCode,
                    zipCode: item.zipCode,
                    city: item.city,
                    address: item.address,
                    typeof: Items[i],

                });
            }
        }
        setDataCustomerDropdown(arr)

        if (!dataServiceListCurrentItem?.client?._id) {
            const defaultClient = arr.find(i => i.typeof === 'orderingParty') || arr[0] || {};
            updateDataServiceListCurrentItem({ ...dataServiceListCurrentItem, client: defaultClient });
        }


    }, []);

    function updateDataServiceListCurrentItem(item) {


        const VAT = determineVatRate({
            orderingParty: dataShipement.orderingParty,
            consignor: dataShipement.consignor,
            consignee: dataShipement.consignee,
        });

        const calculateTotalsForItem = (item) => {
            let quantity = parseFloat(item.quantity) || 0;
            item.quantity = quantity;

            let vatRate = VAT.vatRate?.rate || 0;
            let vatKey = VAT.vatKey || 0;
            item.clientVATRate = vatKey;
            item.supplierVATRate = vatKey;

            // CLIENT
            let clientUnitPrice = parseFloat(item.clientUnitPrice) || 0;
            let clientBase = clientUnitPrice * quantity;
            if (item.clientDiscountAmount > 0 && item.clientDiscountAmount < clientBase) {
                item.clientDiscountRate = 0;
            } else {
                item.clientDiscountAmount = parseFloat(((item.clientDiscountRate / 100) * clientBase).toFixed(2));
            }
            item.clientDiscountAmount = Math.min(item.clientDiscountAmount, clientBase);
            item.clientTotalHT = parseFloat((clientBase - item.clientDiscountAmount).toFixed(2));
            item.clientVAT = parseFloat((item.clientTotalHT * vatRate / 100).toFixed(2));

            // SUPPLIER
            let supplierUnitPrice = parseFloat(item.supplierUnitPrice) || 0;
            let supplierBase = supplierUnitPrice * quantity;
            if (item.supplierDiscountAmount > 0 && item.supplierDiscountAmount < supplierBase) {
                item.supplierDiscountRate = 0;
            } else {
                item.supplierDiscountAmount = parseFloat(((item.supplierDiscountRate / 100) * supplierBase).toFixed(2));
            }
            item.supplierDiscountAmount = Math.min(item.supplierDiscountAmount, supplierBase);
            item.supplierTotalHT = parseFloat((supplierBase - item.supplierDiscountAmount).toFixed(2));
            item.supplierVAT = parseFloat((item.supplierTotalHT * vatRate / 100).toFixed(2));

            return item;
        };

        let newUpdatedList = []

        setDataServiceListCurrentItem(() => {
            let updatedItem = calculateTotalsForItem({ ...item })
            setDataServiceList(prevList => {
                return prevList.map(item => {

                    if (item._id === updatedItem._id) {
                        newUpdatedList.push(updatedItem);
                        return updatedItem
                    } else {
                        newUpdatedList.push(item);
                        return item;
                    }
                });
            });
            return updatedItem;
        }
        );

        calculateTotalsSummaryForShipement({list:newUpdatedList, setDataShipement});

    };


   


    return (
        <>
            <Box
                sx={{
                    mt: 2,
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    padding: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}>

                < Box sx={{ display: 'grid', gridTemplateColumns: '2fr 1fr', alignItems: 'center', gap: 2 }} >

                    <Box sx={{ display: 'grid', gridTemplateColumns: '.5fr 3.5fr', gap: 3, alignItems: 'center' }} >
                        <BillingItemsSearchBox data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} />
                        <Typography variant='body2' color='#00000099' sx={{ fontWeight: 400, fontSize: "1.1rem", }} noWrap > {dataServiceListCurrentItem.itemCode} - {dataServiceListCurrentItem.designation?.[language]} </Typography>

                    </Box>

                    <Box sx={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 2, }} >

                        <CreatFieldComponent field={ModelServiceItem.unit} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} options={Units} />
                        <CreatFieldComponent field={ModelServiceItem.quantity} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} fnParams={'calcAutomaticServiceLine'} />

                    </Box>

                </Box>

                <Divider sx={{ my: 1 }} />

                {/* CLIENT */}
                <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column', justifyContent: 'space-between' }}>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '.5fr 1fr 5fr 2fr',
                            gap: 2,
                        }} >
                        <Typography variant='overline' color='#00000099' sx={{ fontWeight: 600 }} >{page.client}</Typography>

                        <FormControl fullWidth>
                            <InputLabel
                                id={'selector'}
                                sx={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
                                size="small"
                            >{translations.components.serviceList[language].invoiceTo}</InputLabel>
                            <Select
                                labelId={`invoiceTo`}
                                id={`invoiceTo`}
                                value={dataServiceListCurrentItem.client?._id || ''}
                                onChange={(e) =>
                                    updateDataServiceListCurrentItem({ ...dataServiceListCurrentItem, client: dataCustomerDropdown.find(i => i._id === e.target.value) })
                                }
                                variant='outlined'
                                size="small"
                                autoComplete="off"
                                label={translations.components.serviceList[language].invoiceTo}
                            >
                                {dataCustomerDropdown.map((i, index) => (
                                    <MenuItem key={index} value={i._id}>
                                        {ModelShipment[i.typeof][language]} : {i.code} - {i.name} ({i.countryCode})
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TierSelectBox model={ModelServiceItem} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} type={'client'} size={1} />
                        <CreatFieldComponent field={ModelServiceItem.clientInvoiceNumber} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} />

                    </Box>
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr',
                        gap: 2,
                    }} >


                        <CreatFieldComponent field={ModelServiceItem.clientUnitPrice} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} />
                        <CreatFieldComponent field={ModelServiceItem.clientCurrency} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} options={Currencies} />
                        <CreatFieldComponent field={ModelServiceItem.clientVAT} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} />
                        <CreatFieldComponent field={ModelServiceItem.clientVATRate} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} options={TaxRates} />
                        <CreatFieldComponent field={ModelServiceItem.clientDiscountRate} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} />
                        <CreatFieldComponent field={ModelServiceItem.clientDiscountAmount} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} />
                        <CreatFieldComponent field={ModelServiceItem.clientTotalHT} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} disabledInForm={true} />

                    </Box>
                </Box>
                <Divider sx={{ my: 1 }} />


                {/* SUPPLLIER */}
                <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column', justifyContent: 'space-between' }}>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 5fr 2fr',
                            gap: 2,
                        }} >
                        <Typography variant='overline' color='#00000099' sx={{ fontWeight: 600 }} >{page.supplier}</Typography>
                        <TierSelectBox model={ModelServiceItem} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} type={'supplier'} size={1} />
                        <CreatFieldComponent field={ModelServiceItem.supplierInvoiceNumber} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} />
                    </Box>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr',
                            gap: 2,
                        }} >

                        <CreatFieldComponent field={ModelServiceItem.supplierUnitPrice} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} fnParams={'calcAutomaticServiceLine'} />
                        <CreatFieldComponent field={ModelServiceItem.supplierCurrency} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} options={Currencies} />
                        <CreatFieldComponent field={ModelServiceItem.supplierVAT} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} />
                        <CreatFieldComponent field={ModelServiceItem.supplierVATRate} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} options={TaxRates} />
                        <CreatFieldComponent field={ModelServiceItem.supplierDiscountRate} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} />
                        <CreatFieldComponent field={ModelServiceItem.supplierDiscountAmount} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} />
                        <CreatFieldComponent field={ModelServiceItem.supplierTotalHT} data={dataServiceListCurrentItem} updateData={updateDataServiceListCurrentItem} />

                    </Box>
                </Box>

                <Box sx={{ display: 'flex', gap: 2, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>

                    <Button size='small' variant='outlined' color='error' onClick={() => { handleDelete(dataServiceListCurrentItem._id); }} sx={{ minWidth: '30px', padding: '0px', height: '30px', width: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <DeleteOutlineIcon color={'error'} />
                    </Button>

                    
                </Box>

            </Box>
        </>
    )
}


const ServiceList = ({ openServiceList, setOpenServiceList, handleSaveShipement, isLoadingButton, hasChanged }) => {

    const { language,
        dataShipement, setDataShipement,
        dataServiceList, setDataServiceList,

    } = useData();

    const [dataServiceListCurrentItem, setDataServiceListCurrentItem] = useState({});

    // const dataForCalculateShipmentTotals = { dataShipement, updateDataShipement, dataServiceList, updateDataServiceList, }

    const page = translations.components.serviceList[language];
    const btns = translations.button[language];


    const handleClose = () => { setDataServiceListCurrentItem({}); setOpenServiceList(false) };


    const handleDelete = (ID) => {
        setDataServiceListCurrentItem({})

        setDataServiceList(prev => prev.filter(item => item._id !== ID));

    };


    const handleAdd = () => {
        const newItem = createNewServiceItem(null, dataShipement);
        setDataServiceList(prev => [...prev, newItem]);
        setDataServiceListCurrentItem(newItem);
    };



    return (
        <Modal
            open={openServiceList}
            onClose={handleClose}
        >
            <Box sx={style}>

                <HeaderBlock dataShipement={dataShipement} />

                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} >

                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', my: 2 }}>

                        <Button variant="outlined" onClick={handleAdd} >{btns.add}</Button>

                        {/* <Button variant="outlined" onClick={() => console.log(dataServiceListCurrentItem, dataServiceList)} >Print</Button> */}

                    </Box>

                    <Box sx={{ display: 'flex', gap: 4, alignItems: 'center', my: 2 }}>
                        <Button variant="outlined" color={'secondary'} onClick={() =>{ 
                            setDataServiceListCurrentItem({});
                             taxationAutomaticForShipement({ dataShipement, setDataServiceList, setDataShipement })
                             }} >
                            {page.autmaticCalculation}
                        </Button>
                        <Button variant="outlined" onClick={handleClose} >
                            {btns.close}
                        </Button>
                        <Button variant='contained' disabled={!hasChanged} loading={isLoadingButton} color='warning' onClick={handleSaveShipement}>{btns.save}</Button>
                    </Box>

                </Box>

                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '30vh',
                    overflowY: 'auto',
                }} >

                    <Box

                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 3fr 1fr 1fr 1fr 1fr 1fr .1fr',
                            alignItems: 'center',
                            padding: '8px',
                            borderBottom: '1px solid #ccc',

                        }}
                    >
                        <Typography variant="body2" >{ModelServiceItem.itemCode[language]}</Typography>
                        <Typography variant="body2" >{ModelServiceItem.designation[language]}</Typography>
                        <Typography variant="body2" >{ModelServiceItem.client[language]}</Typography>
                        <Typography variant="body2" >{ModelServiceItem.clientTotalHT[language]}</Typography>
                        <Typography variant="body2" >{ModelServiceItem.supplier[language]}</Typography>
                        <Typography variant="body2" >{ModelServiceItem.supplierTotalHT[language]}</Typography>
                        <Typography variant="body2" >{ModelServiceItem.quantity[language]}</Typography>

                    </Box>

                    {dataServiceList.map((i) => {

                        if (!i || !i._id) return null; // Skip if item is not valid
                        return (<Box
                            key={i._id}
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 3fr 1fr 1fr 1fr 1fr 1fr ',
                                alignItems: 'center',
                                padding: '8px',
                                borderBottom: '1px solid #ccc',
                                cursor: 'pointer',
                                backgroundColor: dataServiceListCurrentItem?._id === i?._id ? '#f0f0ff' : 'transparent',
                                '&:hover': {
                                    backgroundColor: '#f0f0f0',
                                }
                            }}
                            onClick={() => { setDataServiceListCurrentItem(i); console.log('Selected item:', i); }}
                        >
                            {/* <Typography variant='body2'>{i._id}</Typography> */}
                            <Typography variant="body2">{i?.itemCode}</Typography>
                            <Typography variant="body2">{i?.designation?.[language]}</Typography>
                            <Typography variant="body2">{i?.client?.code}</Typography>
                            <Typography variant="body2">{i?.clientTotalHT} {i.clientCurrency}</Typography>
                            <Typography variant="body2">{i?.supplier?.code}</Typography>
                            <Typography variant="body2">{i?.supplierTotalHT} {i?.supplierCurrency}</Typography>
                            <Typography variant="body2">{i?.quantity}</Typography>

                        </Box>)
                    })
                    }
                </Box>

                {dataServiceListCurrentItem._id ? <SelectedItem
                    ModelServiceItem={ModelServiceItem}
                    dataServiceListCurrentItem={dataServiceListCurrentItem}
                    setDataServiceListCurrentItem={setDataServiceListCurrentItem}
                    setDataServiceList={setDataServiceList}
                    language={language}
                    page={page}
                    handleDelete={handleDelete}
                /> : ''}

            </Box>


        </Modal >
    );
}

export { ServiceList };

